import { createSelector as createSelectorORM } from 'redux-orm'
import { orm, IORMModels, ISession } from './ConfigureOrm';
import { store } from '..';

export class SelectorBase {
  protected static getDataSource(): ISession<IORMModels> {
    const ormSelector = createSelectorORM(
      orm,
      (session: ISession<IORMModels>) => session
    );

    return ormSelector(store.getState().orm3);
  }
}



// WEBPACK FOOTER //
// ./src/Config/SelectorBase.ts